/**
 * * @module component/promo-blocks.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";

const PromoBlock = Backbone.View.extend({
  el: $(document),

  events: {
    "click .people-block .show-more": "showMore",
  },

  initialize: function () {
    this.render();
  },

  resizePromoBlocks: function () {
    let width = $("body").innerWidth();

    if ($(window).width() <= 414) {
      $(".promo-block-wrapper").width(width).addClass("resized");
    } else if ($(window).width() > 414 && $(window).width() <= 768) {
      // $(".promo-block-wrapper:not(.two-blocks)").width(width).addClass("resized");
      $(".promo-block-wrapper:not(.two-blocks)")
        .parent(".promo-blocks-container")
        .addClass("resized");
    }

    $(window).resize(function (event) {
        let $promoBlockContainer = $(".promo-block-wrapper");
        if ($(window).width() < 768) {
          if (!$promoBlockContainer.hasClass("resized")) {
            let width = $("body").innerWidth();
            $promoBlockContainer.width(width).addClass("resized");
          }
        } else {
          if ($promoBlockContainer.hasClass("resized")) {
            $promoBlockContainer.width("100%").removeClass("resized");
          }
        }
      });

  },

  render: function () {
    // this.resizePromoBlocks();
  },
});

export default PromoBlock;
